<template>
    <v-dialog
      v-model="show"
      hide-overlay
      fullscreen
      transition="dialog-bottom-transition"
    >
      <div id="app" class="my-0 py-0">
        <v-app id="inspire">
          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card v-model="show" class="py-0">
              <v-toolbar class="py-0 my-0" dark color="blue">
                <v-toolbar-title class="my-0 py-0">
                   {{titulo}} 
                   
                </v-toolbar-title
                >
                <v-spacer></v-spacer>
             
                <v-spacer></v-spacer>
                <div>
                  <v-btn icon @click="salir()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-toolbar>
            </v-card>
            
            <v-card color="blue lighten-4" class="py-0 my-0">
              <v-card-text class="py-0 my-0">
                <v-row dense>
                  <v-col cols="6" sm="4" md="4">
                    Orden de Trabajo: {{ vOT.Otrabajo }} -  {{ vOT.Detalle }}
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6" sm="4" md="4">
                    Fecha Pedida: {{ vDatos.Fecha }}
                  </v-col>
                  <v-col cols="6" sm="4" md="4">
                    Comprobante: {{ vDatos.Comprobante }}
                  </v-col>
                </v-row>  
                <v-row dense>
                  <v-col cols="6" sm="4" md="4">
                    Resp.Tecnico:    {{ vDatos.Tecnico }}                
                  </v-col>
                  <v-col cols="6" sm="4" md="4">
                    Resp.Comercial:   {{ vDatos.Comercial }}                 
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" >
                    Nota:    {{ vOT.Nota1 }}                
                  </v-col>
                </v-row>    
                <v-row dense>
                  <v-col v-if="desserts.length>0">                    
                    <v-data-table
                                    :headers="headers"
                                    :items="desserts"                           
                                    class="elevation-1"
                                    :items-per-page="desserts.length"
                        >
                        </v-data-table>        
                  </v-col>
                  <v-col v-if="desserts1.length> 0">
                    <v-data-table
                                    :headers="headers1"
                                    :items="desserts1"                           
                                    class="elevation-1"
                                    :items-per-page="desserts1.length"
                        >
                        </v-data-table>        
                  </v-col>
                </v-row>                  
                <v-row dense>
                  <v-col cols="6" sm="4" md="4">
                    Observación:    {{ vDatos.Observa }}                
                  </v-col>                 
                </v-row> 
                <v-row dense>
                  <v-col cols="6" sm="4" md="6">
                    Lugar Entrega:    {{ vDatos.Lug_Ent }}                
                  </v-col> 
                  <v-col cols="6" sm="4" md="6">
                    Items Ins:    {{ vDatos.ItemsIns }}                
                  </v-col>                 
                </v-row>  
                
                <v-row>
                    
                    <v-col>
                        <v-btn block color="blue" @click="imprimir(vOT.Otrabajo,vDatos.Comprobante, codgral)">
                            Imprimir 
                        </v-btn>
                    </v-col>               

              
                </v-row>
                
              </v-card-text>
            </v-card>
           
  
            <v-card color="blue lighten-5">
              <v-card-text class="py-0 my-0">
              
              </v-card-text>
            </v-card>
            
            
  
            
          </v-form>
        </v-app>
      </div>
    </v-dialog>
  </template>
  
  <style scoped>
  .multi-line {
    white-space: pre-line;
  }
  </style>
  <script>
  import moment from "moment";
  import Axios from "../../../axios-auth-sistemas";
  import jsPDF from "jspdf"; 
  import "jspdf-autotable";

  export default {

    name:'EI026_Link',

    data: (vm) => ({
    
      valid: false,
      validsubir: false,
      lazy: false,
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      visible: true,
      codgral:"",
      titulo:"",
      comp:"",
      ot:"",
      vOT: {
        Otrabajo:"",
        Detalle:"",
        Nota1:""
      },

      headers: 
            [            
            {text: 'Item',value: 'item',  align: "center",sortable: false},                  
            {text: 'Articulo',value: 'articulo' ,  width: "0%",sortable: false },
            {text: 'Detalle',value: 'detalle', width: "350",  sortable: false,align: 'left'},
            {text: 'FF',value: 'ff',  align: "left",sortable: false }, 
            {text: 'Cantidad',value: 'cantidad',  align: "left",sortable: false }, 
            {text: 'Unidad',value: 'unidad',  align: "left",sortable: false }, 
            {text: 'Tipo Mat.',value: 'tipoMat',  align: "left",sortable: false },  
            {text: 'Fecha Nec.',value: 'fecha_nec',  align: "left",sortable: false }, 
            {text: 'Moneda',value: 'moneda' ,  align: "left",sortable: false},  
            {text: 'Cant. Pres.',value: 'cantPres',  align: "left",sortable: false },  
            {text: 'Precio Unitario Pres.',value: 'precioPre',  align: "left",sortable: false }, 
            {text: 'Ins.',value: 'ins',  align: "left",sortable: false }, 
            {text: 'Seguimiento', value: 'seguimiento',  align: "left",sortable: false },                                       
            // {text: 'detalle_completo',value: 'detalleCompleto' ,  align: "center",sortable: false}, 
            ], 
      headers1: 
              [
              {text: 'Item Reemplazado',value: 'devuelto',  align: "center",sortable: false},  
              {text: 'Item Nuevo',value: 'item',  align: "center",sortable: false},                  
              {text: 'Articulo',value: 'articulo' ,  width: "0%",sortable: false },
              {text: 'Detalle',value: 'detalle', width: "350",  sortable: false,align: 'left'},
              {text: 'FF',value: 'ff',  align: "left",sortable: false }, 
              {text: 'Cantidad',value: 'cantidad',  align: "left",sortable: false }, 
              {text: 'Unidad',value: 'unidad',  align: "left",sortable: false }, 
              {text: 'Tipo Mat.',value: 'tipoMat',  align: "left",sortable: false },  
              {text: 'Fecha Nec.',value: 'fecha_nec',  align: "left",sortable: false }, 
              {text: 'Moneda',value: 'moneda' ,  align: "left",sortable: false},  
              {text: 'Cant. Pres.',value: 'cantPres',  align: "left",sortable: false },  
              {text: 'Precio Unitario Pres.',value: 'precioPre',  align: "left",sortable: false }, 
              {text: 'Ins.',value: 'ins',  align: "left",sortable: false }, 
              {text: 'Seguimiento', value: 'seg',  align: "left",sortable: false },                                       
              // {text: 'detalle_completo',value: 'detalleCompleto' ,  align: "center",sortable: false}, 
              ], 
        desserts:[], 
        desserts1:[],
        desserts3:[], 
        desserts4:[], 
        vDatos: {
        Comprobante:"",
        Tecnico:"",
        Comercial:"",
        Lug_Ent: "",
        Observa:"",
        ItemsIns:"",
        Fecha: "",
        Nota1:""
      },

    
      
      
     
    }),
  
   
    computed: {
      show: {
        get() {        
  
          return this.visible;
        },
        set(value) {
          if (!value) {
            this.vaciarListado();
            this.$refs.form.resetValidation();
            document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
            this.$emit("close");
          }
        },
      },
    },
    mounted() {
           
            this.codgral = this.$route.query.codgral;
            this.ot = this.$route.query.ot;
            this.comp = this.$route.query.comp;
            this.cargarEI026(this.codgral,this.ot, this.comp);

            return this.visible;
    },
    methods: { 
      
       salir(){
        this.visible=false;
       },

        cargarEI026(codgral,ot,comp) {
            
            switch (codgral) {
      
            case "1":
                this.titulo="Nueva Solicitud de Materiales (EI026)";
                break;
            case "3":
                this.titulo="Nuevo Reemplazo de Materiales (EI026)";
                break;
            case "5":
                this.titulo="Nueva Anulación de Materiales (EI026)";
                break;

            }

            this.mostrarCabeceraOT(ot);

            if (codgral === "1") {
              this.mostrarDetalleOT(ot, comp, codgral);
            }
            
            if (codgral === "3") {
              this.mostrarReemplazo(ot, comp, codgral);
            }

            if (codgral === "5") {
              this.mostrarDetalleOT(ot, comp, codgral);
            }
        },

        mostrarCabeceraOT(id){
                let self = this; 
                self.desserts=[];            
                Axios
                .get("/CtaOtPro/Getnombreot?", {
                params: {
                    id: id,
                },
                })
                .then((r) => {             
                  console.log("datos", r.data)  

                    self.btnSol=true
                    self.vOT.Otrabajo = r.data[0].otrabajo
                    self.vOT.Detalle = r.data[0].detalle 
                      self.vOT.Nota1 = r.data[0].nota1                    
                })
                .catch((error) => {                    
                    self.vOT=[];
                    self.desserts=[]   
                                
                }); 
        },

        mostrarDetalleOT(id, id1, id2){

                let self = this;             
                Axios
                .get("/SolicitudEI026/LinkEI026?", {
                params: {
                    id: id,
                    id1: id1,
                    id2: id2
                },
                })
                .then((r) => {                 

              
                r.data.forEach(element => {
                      self.desserts.push({
                          item  :element.cantidad > 0  ? element.item :"" ,
                          articulo : element.cantidad > 0 ? element.articulo  : "",
                          detalle :  element.detalle ,
                          cantidad : element.cantidad > 0 ? element.cantidad  : "",
                          unidad :  element.cantidad > 0 ? element.unidad  : "" , 
                          tipoMat : element.cantidad > 0 ? element.tipoMat  : "" ,
                          fecha_nec : element.cantidad > 0 ? moment(element.fecha_nec).format("DD/MM/YYYY")  : "", 
                          moneda : element.cantidad > 0 ? element.moneda  : "" ,
                          cantPres : element.cantidad > 0 ? element.cantPres  : "" ,
                          precioPre :  element.cantidad > 0 ? element.precioPre  : "",
                          ff : element.cantidad > 0 ? element.ff  : "",
                          ins : element.cantidad > 0 ? element.ins  : "" ,
                          seguimiento : element.cantidad > 0 ? element.seguimiento  : "",
                      })


                      self.vDatos.Comprobante= element.comprob;
                      self.vDatos.Tecnico= element.tecnico;
                      self.vDatos.Comercial= element.comercial;
                      self.vDatos.Observa= element.observa;
                      self.vDatos.ItemsIns= element.itemsIns;
                      self.vDatos.Lug_Ent= element.lug_Ent;
                      self.vDatos.Fecha= moment(element.fecha_ped).format("DD/MM/YYYY") ;

                    
                  }); 
                  
          

                            
              })                  
                .catch((error) => {                    
                    self.vOT=[];
                    self.desserts=[]   
                                
              });               

        },
        

        mostrarReemplazo(id, id1, id2){
            // console.log("mostarReemplazo")
            // console.log(id)
            // console.log(id1)
            // console.log(id2)

            let self = this;             
            Axios
            .get("/SolicitudEI026/LinkEI026?", {
            params: {
                id: id,
                id1: id1,
                id2: id2
            },
            })
            .then((r) => {
              
              

            r.data.forEach(element => {
                  self.desserts1.push({
                      devuelto :element.devuelto == null || element.devuelto =="" ? ""  : element.item,
                      item  :element.devuelto == null || element.devuelto == "" ? element.item  :"",
                      articulo: element.item == null ? ""  : element.articulo,
                      detalle: element.item == null ? ""  : element.item == null ? ""  : element.detalle,                      
                      cantidad :element.devuelto == null || element.devuelto =="" ? element.cantidad  : element.recibida,
                      unidad: element.item == null ? ""  : element.unidad, 
                      tipoMat: element.item == null ? ""  : element.tipoMat,
                      fecha_nec :element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"), 
                      moneda: element.item == null ? ""  : element.moneda,
                      cantPres: element.item == null ? ""  : element.cantPres,
                      precioPre:  element.item == null ? ""  : element.precioPre,
                      ff: element.item == null ? ""  : element.ff,
                      ins: element.item == null ? ""  : element.ins,
                      seguimiento: element.item == null ? ""  : element.seguimiento,
                  })

                  self.vDatos.Comprobante= element.comprob;
                  self.vDatos.Tecnico= element.tecnico;
                  self.vDatos.Comercial= element.comercial;
                  self.vDatos.Observa= element.observa;
                  self.vDatos.ItemsIns= element.itemsIns;
                  self.vDatos.Lug_Ent= element.lug_Ent;
                  self.vDatos.Fecha= moment(element.fecha_ped).format("DD/MM/YYYY") ;


              });                    
                        
            })                  
            .catch((error) => {                    
                self.vOT=[];
                self.desserts=[]   
                self.desserts1=[]              
            });               

        },

        imprimir(pot, pcomp, codgral){

            console.log(pot)
            console.log(pcomp)
            let self = this;                
            self.desserts3 = [];

            // SOLICITUD //
            if (codgral == "1" )
            {
              
                    Axios
                  .get("/SolicitudEI026/GetEI026PDF2?", {
                      params: {
                          id: pot , 
                          id1: pcomp,
                          id2: '1'
                      },
                  })
                  .then((response) => {       

                          console.log("imprimir")     
                        //  console.log(response.data)
                      

                          response.data.forEach(element => {

                              console.log(element.item)                        
                              self.desserts3.push({
                                  item: element.item,
                                  articulo: element.articulo,
                                  cantPres: element.cantPres,
                                  cantidad: element.cantidad,
                                  comercial: element.comercial,
                                  comprob: pcomp,
                                  detalle: element.detalle,
                                  fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                  fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                  ff: element.ff,
                                  iitem: element.iitem,
                                  ins: element.ins,
                                  itemIns: element.itemIns,
                                  lugEnt: element.lugEnt,
                                  moneda: element.moneda,
                                  nombre: element.nombre,
                                  nota: element.nota,
                                  observa: element.observa,
                                  otrabajo: element.otrabajo,
                                  precioPre: element.precioPre,
                                  renglon: element.renglon,
                                  seguimiento: element.seguimiento,
                                  tipoMat: element.tipoMat,
                                  unidad: element.unidad,
                                  tecnico: element.tecnico,
                                  ot: pot,
                              })
                          });

                          
                          console.log("PDF1")
                       //   console.log(self.desserts3)
                          
                          

                          self.generarPDF();


                  })
                  .catch(r => {
                      console.log("error !")
                  });


            }
            

            //REEMPLAZO//
            if (codgral == "3" )
            {

                  let self = this;                
                  self.desserts3=[];
                  self.desserts4=[];
                 
                  Axios
                  .get("/SolicitudEI026/LinkEI026?", {
                      params: {
                          id: pot , 
                          id1: pcomp,
                          id2: '3'
                      },
                  })
                  .then((response) => {       

                       
                        
                      

                          response.data.forEach(element => {

                              if(element.recibida == null || element.recibida == 0) {

                                      self.desserts3.push({
                                      recibida: element.recibida,
                                      devuelto: element.devuelto,
                                      item: element.item,
                                      articulo: element.articulo,
                                      detalle: element.detalle,
                                      cantidad: element.estado == '3' ? '' : element.cantidad,
                                      unidad: element.unidad,
                                      tipoMat: element.tipoMat,
                                      unidad: element.unidad,
                                      fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                      fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                      comprob: element.comprob,
                                      moneda: element.moneda,
                                      precioPre: element.precioPre,
                                      cantPres: element.cantPres,
                                      comercial: element.comercial,
                                      tecnico: element.tecnico,                                
                                      ff: element.ff == 'N' ? "" : element.ff,
                                      iitem: element.iitem,
                                      ins: element.ins,
                                      seguimiento: element.seguimiento,
                                      observa: element.observa,                            
                                      itemIns: element.itemsIns,                            
                                      lugEnt: element.lug_Ent,
                                      otrabajo:  pot,
                                      nombre: self.vOT.Detalle,
                                      nota: element.nota

                                  })
                                                
                              }
                              else
                              {

                                  self.desserts4.push({
                                      recibida: element.recibida,
                                      devuelto: element.devuelto,
                                      item: element.item,
                                      articulo: element.articulo,
                                      detalle: element.detalle,
                                      cantidad: element.estado == '3' ? '' : element.cantidad,
                                      unidad: element.unidad,
                                      tipoMat: element.tipoMat,
                                      unidad: element.unidad,
                                      fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                      fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                      comprob: element.comprob,
                                      moneda: element.moneda,
                                      precioPre: element.precioPre,
                                      cantPres: element.cantPres,
                                      comercial: element.comercial,
                                      tecnico: element.tecnico,                                
                                      ff: element.ff == 'N' ? "" : element.ff,
                                      iitem: element.iitem,
                                      ins: element.ins,
                                      seguimiento: element.seguimiento,
                                      observa: element.observa,                            
                                      itemIns: element.itemsIns,                            
                                      lugEnt: element.lug_Ent,
                                      nota: element.nota,
                                      otrabajo: pot,
                                      nombre:  self.vOT.Detalle
                                  })


                              }


                          });

                          
                          console.log("PDF1")
                       //   console.log(self.desserts3)
                       //   console.log(self.desserts4)
                          

                          self.generarPDFREEM();


                  })
                  .catch(r => {
                      console.log("error LinkEI026!")
                  });


            }


            //ANULACION //
            if(codgral == "5")
            {

                  let self = this;                
                    self.desserts3=[];
               
                    Axios
                    .get("/SolicitudEI026/LinkEI026?", {
                        params: {
                            id: pot , 
                            id1: pcomp,
                            id2: '5'
                        },
                    })
                    .then((response) => {       
                            response.data.forEach(element => {                  
                                    self.desserts3.push({
                                    recibida: element.recibida,
                                    devuelto: element.devuelto,
                                    item: element.item,
                                    articulo: element.articulo,
                                    detalle: element.detalle,
                                    cantidad: element.cantidad,
                                    unidad: element.unidad,
                                    tipoMat: element.tipoMat,
                                    unidad: element.unidad,
                                    fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                    fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                    comprob: element.comprob,
                                    moneda: element.moneda,
                                    precioPre: element.precioPre,
                                    cantPres: element.cantPres,
                                    comercial: element.comercial,
                                    tecnico: element.tecnico,                                
                                    ff: element.ff == 'N' ? "" : element.ff,
                                    iitem: element.iitem,
                                    ins: element.ins,
                                    seguimiento: element.seguimiento,
                                    observa: element.observa,                            
                                    itemIns: element.itemsIns,                            
                                    lugEnt: element.lug_Ent,
                                    otrabajo: pot,
                                    nombre: self.vOT.Detalle,
                                    nota: element.nota

                                })                                       
                        });

                            
                            console.log("PDF1")
                          //  console.log(self.desserts3)                  
                            self.generarPDFANU();


                    })
                    .catch(r => {
                        console.log("error !")
                    });

            }

        },



    generarPDF(){

  
   // console.log(this.desserts3[0])

    var vm = this;      
    var columns = [
    {title: "IT", dataKey: "item"},
    {title: "Código", dataKey: "articulo"},
    {title: "FF", dataKey: "ff"},
    {title: "I-P", dataKey: "ins"},
    {title: "Critico", dataKey: "seguimiento"},
    {title: "Cant.", dataKey: "cantidad"},
    {title: "Un.", dataKey: "unidad"},
    {title: "Descripcion", dataKey: "detalle"},
    {title: "Tipo", dataKey: "tipoMat"},
    {title: "Mon.", dataKey: "moneda"},
    {title: "Cant. Pres.", dataKey: "cantPres"},  
    {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
    {title: "Fecha Nec.", dataKey: "fecha_nec"},


    ];
    var doc = new jsPDF();
    doc.setLineWidth(0.5);
    doc.line(10, 11, 200, 11);           
    doc.line(10, 11, 10, 41);
    doc.line(165, 24, 200, 24);
    doc.line(165, 33, 200, 33);
    doc.addImage(
        "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",
        "JPEG",
        15,
        15,
        22,
        22
    );
    doc.setFontSize(13);
    doc.text("PLANILLA DE MATERIALES" , 75, 20);
    doc.setFontSize(12);
    doc.text("SOLICITUD N° " + vm.desserts3[0].comprob  , 80, 26);
    doc.setFontSize(8);
    doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
    doc.setFontSize(6);
    doc.text("Nota: " +vm.desserts3[0].nota , 42, 38);
    doc.setFontSize(14);
    doc.text("OT N°: " + vm.desserts3[0].otrabajo , 166, 20);
    doc.line(40, 11, 40, 41);
    doc.setFontSize(10);
    doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);
    // doc.line(35, 11, 35, 41);
    doc.setFontSize(11);
    doc.text("EI026 Rev. 5" , 170, 38);
    doc.line(40, 11, 40, 41);
    doc.line(165, 11, 165, 41);
    doc.line(10, 41, 200, 41);
    doc.line(200, 11, 200, 41);
    doc.setFontSize(10);


    doc.autoTable(columns, this.desserts3, { 
      theme: 'grid', 
      startY: 45,
      margin: { top: 25, left: 10 , right: 10},
      styles: { fontSize: 7 }
      
    });



    var finalO =  doc.autoTable.previous.finalY + 30;

    if (finalO >= 285) {
        doc.addPage();
        finalO = 0;
    }



    doc.setFontSize(11);


    doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 15);
    doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 20);

    doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 30 );            
    doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 35 )          

    finalO = finalO + 40;
    doc.text("Observaciones:", 10, finalO);
    
    if ( vm.desserts3[0].observa != '' &&  vm.desserts3[0].observa != null)
    {

            var textoSplit = vm.desserts3[0].observa.split(/\r|\n\r|\n/);
            for (var i = 0; i < textoSplit.length; i++) 
            {
              
                  finalO = finalO + 5;
                  if (textoSplit[i].length < 75) {
                  
                    doc.text(textoSplit[i], 10, finalO);

                  } 
                  
                  else 
                  {

                    var lineSplit = textoSplit[i].split(" ");
                    var linePrint = "";
                    var lineTemp = "";

                    for (var j = 0; j < lineSplit.length; j++) {
                      if (linePrint.length >= 72) {
                        console.log("linea: " + lineSplit[j]);
                        if (j == lineSplit.length - 1)
                          doc.text(lineSplit[j], 10, finalO + 5);

                        lineTemp = linePrint + lineSplit[j];
                        if (lineTemp.length < 72) {
                          doc.text(lineTemp, 10, finalO);
                          linePrint = "";
                        } else {
                          doc.text(linePrint, 10, finalO);
                          linePrint = lineSplit[j] + " ";
                        }
                        finalO = finalO + 5;

                        if (finalO > 285) {
                          doc.addPage();
                          finalO = 20;
                        }
                      } else {
                        linePrint = linePrint + lineSplit[j] + " ";
                        if (j == lineSplit.length - 1) {
                          doc.text(linePrint, 10, finalO);
                          if (finalO > 285) {
                            doc.addPage();
                            finalO = 20;
                          }
                        }
                      }
                    }
                }

                
              
            }

    }

    
   
  
    
     



    const pageCount = doc.internal.getNumberOfPages();

    for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
        "Página " + String(i) + " de " + String(pageCount),
        210 - 20,
        297 - 10,
        null,
        null,
        "right"
        );
    }

    doc.save('table.pdf');

    },

    generarPDFREEM(){
            
           
            var vm = this;  

            var columns = [
            {title: "IT", dataKey: "item"},
            {title: "Código", dataKey: "articulo"},
            {title: "Cant.", dataKey: "cantidad"},
            {title: "Un.", dataKey: "unidad"},
            {title: "FF", dataKey: "ff"},            
            {title: "I-P", dataKey: "ins"},
            {title: "Descripcion", dataKey: "detalle"},
            {title: "Critico", dataKey: "seguimiento"},        
            {title: "Cant. Pres.", dataKey: "cantPres"},  
            {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
            {title: "Fecha Nec.", dataKey: "fecha_nec"},           
             ];

             var columns1 = [               
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "articulo"},
                {title: "Cant.", dataKey: "cantidad"},
                {title: "Un.", dataKey: "unidad"},
                {title: "FF", dataKey: "ff"},            
                {title: "I-P", dataKey: "ins"},
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Critico", dataKey: "seguimiento"},
                {title: "Item Nvo", dataKey: "devuelto"},
                {title: "Cant. Pres.", dataKey: "cantPres"},  
                {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                {title: "Fecha Nec.", dataKey: "fecha_nec"},      
            ];    

            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);           
            doc.line(10, 11, 10, 41);
            doc.line(165, 24, 200, 24);
            doc.line(165, 33, 200, 33);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(13);
            doc.text("PLANILLA DE MATERIALES" , 75, 20);
            doc.setFontSize(12);
            doc.text("Reemplazo N° " + vm.desserts3[0].comprob  , 80, 26);
            doc.setFontSize(8);
            doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
            doc.setFontSize(6);
            doc.text("Nota: " + vm.desserts3[0].nota , 42, 38);
            doc.setFontSize(14);
            doc.text("OT N°: " + vm.desserts3[0].otrabajo  , 166, 20);
            doc.line(40, 11, 40, 41);
            doc.setFontSize(10);
            doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);         
            doc.setFontSize(11);
            doc.text("EI026 Rev. 5" , 170, 38);
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);
        
            doc.setTextColor("red");
            doc.text("NUEVOS MATERIALES ", 75,46 );

            doc.autoTable({
            theme: 'grid',    
            columns: columns,
            body: this.desserts3,
            startY: 48,
            margin: { top: 25, left: 10, right: 10 },
            styles: { fontSize: 7 },          
            });

            var finalO =  doc.autoTable.previous.finalY + 30;

            if (finalO >= 285) {
                doc.addPage();
                finalO = 0;
            }


            doc.setTextColor("red");
            doc.text("MATERIALES REEMPLAZADOS", 75,doc.autoTable.previous.finalY + 8 );
                
            doc.autoTable({
            theme: 'grid', 
            columns: columns1,
            body: this.desserts4,
            startY: doc.autoTable.previous.finalY + 10,
            margin: { top: 25, left: 10, right: 10 },
            styles: { fontSize: 7 }
            });


            var finalO =  doc.autoTable.previous.finalY + 30;

          
           doc.setFontSize(11);
            
           

            doc.setTextColor("black");


            doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 15);
            doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 20);

            doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 30 );            
            doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 35 )          

            finalO = finalO + 40;
            doc.text("Observaciones:", 10, finalO);    


            if ( vm.desserts3[0].observa != '' &&  vm.desserts3[0].observa != null)
            {

                var textoSplit = vm.desserts3[0].observa.split(/\r|\n\r|\n/);
   
  
    
                for (var i = 0; i < textoSplit.length; i++) 
                {
     
                  finalO = finalO + 5;
                  if (textoSplit[i].length < 75) 
                  {
                  
                    doc.text(textoSplit[i], 10, finalO);

                  } 
         
                  else 
                  {

                        var lineSplit = textoSplit[i].split(" ");
                        var linePrint = "";
                        var lineTemp = "";

                        for (var j = 0; j < lineSplit.length; j++) {
                          if (linePrint.length >= 72) {
                            console.log("linea: " + lineSplit[j]);
                            if (j == lineSplit.length - 1)
                              doc.text(lineSplit[j], 10, finalO + 5);

                            lineTemp = linePrint + lineSplit[j];
                            if (lineTemp.length < 72) {
                              doc.text(lineTemp, 10, finalO);
                              linePrint = "";
                            } else {
                              doc.text(linePrint, 10, finalO);
                              linePrint = lineSplit[j] + " ";
                            }
                            finalO = finalO + 5;

                            if (finalO > 285) {
                              doc.addPage();
                              finalO = 20;
                            }
                          } else {
                            linePrint = linePrint + lineSplit[j] + " ";
                            if (j == lineSplit.length - 1) {
                              doc.text(linePrint, 10, finalO);
                              if (finalO > 285) {
                                doc.addPage();
                                finalO = 20;
                              }
                            }
                          }
                        }
                  }

                }   
            }

           






          //   doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
          //   doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
          //  // doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
          //   doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
          //   doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);

           
            
     
            const pageCount = doc.internal.getNumberOfPages();

            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                "Página " + String(i) + " de " + String(pageCount),
                210 - 20,
                297 - 10,
                null,
                null,
                "right"
                );
            }

            doc.save('table.pdf');

    },

    
   

    generarPDFANU(){         
           
          
                var vm = this;      
                var columns = [
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "articulo"},
                {title: "Cant. Anulada", dataKey: "cantidad"},
                {title: "Un.", dataKey: "unidad"},
                {title: "FF", dataKey: "ff"},            
                {title: "I-P", dataKey: "ins"},
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Critico", dataKey: "seguimiento"},        
                {title: "Cant. Pres.", dataKey: "cantPres"},  
                {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                {title: "Fecha Nec.", dataKey: "fecha_nec"},           
                  ];           

                var doc = new jsPDF();
                doc.setLineWidth(0.5);
                doc.line(10, 11, 200, 11);           
                doc.line(10, 11, 10, 41);
                doc.line(165, 24, 200, 24);
                doc.line(165, 33, 200, 33);
                doc.addImage(
                    "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",
                    "JPEG",
                    15,
                    15,
                    22,
                    22
                );
                doc.setFontSize(13);
                doc.text("PLANILLA DE MATERIALES" , 75, 20);
                doc.setFontSize(12);
                doc.text("Anulación N° " + vm.desserts3[0].comprob  , 80, 26);
                doc.setFontSize(8);
                doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
                doc.setFontSize(6);
                doc.text("Nota: " +vm.desserts3[0].nota , 42, 38);
                doc.setFontSize(14);
                doc.text("OT N°: " + vm.desserts3[0].otrabajo , 166, 20);
                doc.line(40, 11, 40, 41);
                doc.setFontSize(10);
                doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);         
                doc.setFontSize(11);
                doc.text("EI026 Rev. 5" , 170, 38);
                doc.line(40, 11, 40, 41);
                doc.line(165, 11, 165, 41);
                doc.line(10, 41, 200, 41);
                doc.line(200, 11, 200, 41);
                doc.setFontSize(10);
            
                

                doc.autoTable({
                theme: 'grid',    
                columns: columns,
                body: this.desserts3,
                startY: 48,
                margin: { top: 25, left: 10, right: 10 },
                styles: { fontSize: 7 },          
                });

                var finalO =  doc.autoTable.previous.finalY + 30;

                if (finalO >= 285) {
                    doc.addPage();
                    finalO = 0;
                }


            

              
                doc.setFontSize(11);

                doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 15);
                doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 20);

                doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 30 );            
                doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 35 )          

                finalO = finalO + 40;
                doc.text("Observaciones:", 10, finalO);    

                if ( vm.desserts3[0].observa != '' &&  vm.desserts3[0].observa != null)
                {

                      var textoSplit = vm.desserts3[0].observa.split(/\r|\n\r|\n/);
   
                      for (var i = 0; i < textoSplit.length; i++) 
                      {
                        
                            finalO = finalO + 5;
                            if (textoSplit[i].length < 75) {
                            
                              doc.text(textoSplit[i], 10, finalO);

                            } 
                            
                            else 
                            {

                              var lineSplit = textoSplit[i].split(" ");
                              var linePrint = "";
                              var lineTemp = "";

                              for (var j = 0; j < lineSplit.length; j++) {
                                if (linePrint.length >= 72) {
                                  console.log("linea: " + lineSplit[j]);
                                  if (j == lineSplit.length - 1)
                                    doc.text(lineSplit[j], 10, finalO + 5);

                                  lineTemp = linePrint + lineSplit[j];
                                  if (lineTemp.length < 72) {
                                    doc.text(lineTemp, 10, finalO);
                                    linePrint = "";
                                  } else {
                                    doc.text(linePrint, 10, finalO);
                                    linePrint = lineSplit[j] + " ";
                                  }
                                  finalO = finalO + 5;

                                  if (finalO > 285) {
                                    doc.addPage();
                                    finalO = 20;
                                  }
                                } else {
                                  linePrint = linePrint + lineSplit[j] + " ";
                                  if (j == lineSplit.length - 1) {
                                    doc.text(linePrint, 10, finalO);
                                    if (finalO > 285) {
                                      doc.addPage();
                                      finalO = 20;
                                    }
                                  }
                                }
                              }
                          }  

                      }  




                }

                
  
    
              


                
            
                // doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
                // doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
                // doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
                // doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                // doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);



                

              
                
          
                  const pageCount = doc.internal.getNumberOfPages();

                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.text(
                    "Página " + String(i) + " de " + String(pageCount),
                    210 - 20,
                    297 - 10,
                    null,
                    null,
                    "right"
                    );
                }

                doc.save('table.pdf');

       },


    }
   
  };
  </script>
  